import React from 'react';
import { cx } from './cx';
import { playClickSound } from '@/utils/soundUtils';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'filled' | 'outline';
  size?: 'lg' | 'md' | 'sm';
  'aria-label': string;
  /** Skip automatic click sound. */
  silent?: boolean;
}

const SIZES = { lg: 'w-12 h-12', md: 'w-10 h-10', sm: 'w-8 h-8' } as const;

/** Cosmos icon button (1c): filled magenta or ice outline. */
const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { variant = 'outline', size = 'md', className, children, silent = false, disabled, onClick, ...rest },
  ref
) {
  return (
    <button
      ref={ref}
      type="button"
      disabled={disabled}
      onClick={(e) => {
        if (!disabled && !silent) playClickSound();
        onClick?.(e);
      }}
      className={cx(
        'inline-flex items-center justify-center rounded-control transition-all duration-150',
        'focus-visible:outline-none focus-visible:shadow-focus-ring active:translate-y-px',
        variant === 'filled'
          ? 'bg-gradient-to-b from-money-in to-money-in-deep text-white border-0 shadow-glow-magenta hover:brightness-110'
          : 'bg-white/5 text-ice border border-border-ice hover:bg-white/10 hover:text-ink',
        SIZES[size],
        className
      )}
      {...rest}
    >
      <span className="inline-flex [&>svg]:w-[18px] [&>svg]:h-[18px]">{children}</span>
    </button>
  );
});

export default IconButton;
